import { namespace } from 'vuex-class';
import Component from 'vue-class-component';
import store from '@/store';
import { Vue } from 'vue-property-decorator';
import { ERKENNING_BEPERKT_DIALOG_SHOWN_KEY } from '@/util/constants/constants';
import LocalStorageService from '@/services/LocalStorageService';

const Gebruiker = namespace('Gebruiker');
@Component({
  store,
})
export default class GebruikerInfoService extends Vue {
  public async updateGebruikerDeskDWithGeschorstIngetrokkenToken(): Promise<void> {
    this.localStorageService.setItem(ERKENNING_BEPERKT_DIALOG_SHOWN_KEY, false);
    return await this.updateGebruiker();
  }

  public setLocalStorageService(localStorageService: LocalStorageService) {
    this.localStorageService = localStorageService;
  }

  @Gebruiker.Getter('doelgroep')
  public doelgroep!: string;
  @Gebruiker.Getter('voornaam')
  public voornaam!: string;
  @Gebruiker.Getter('roepnaam')
  public roepnaam!: string;
  @Gebruiker.Getter('volledigeNaam')
  public volledigeNaam!: string;
  @Gebruiker.Getter('initialen')
  public initialen!: string;
  @Gebruiker.Getter('erkenningsnummer')
  public erkenningsnummer!: string;
  @Gebruiker.Getter('erkenningsstatus')
  public erkenningsstatus!: string;
  @Gebruiker.Getter('registratierollen')
  public registratierollen!: string;
  @Gebruiker.Getter('ondernemingInfo')
  public ondernemingInfo!: string;
  @Gebruiker.Getter('controleur')
  public controleur!: boolean;
  @Gebruiker.Getter('geschorstDeskD')
  public geschorstDeskD!: boolean;
  @Gebruiker.Getter('ingetrokkenDeskD')
  public ingetrokkenDeskD!: boolean;
  private localStorageService: LocalStorageService;
  @Gebruiker.Action
  private readonly updateGebruiker!: () => Promise<void>;
}
